/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.InventoryTransfer {
    angular.module("meevo.plugins.inventoryTransfer", []);
}